import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAddresses } from 'app/entities/address/address.reducer';
import { getEntities as getCustomerOrders } from 'app/entities/customer-order/customer-order.reducer';
import { ProductOrderStatus } from 'app/shared/model/enumerations/product-order-status.model';
import { createEntity, getEntity, reset, updateEntity } from './product-order.reducer';

export const ProductOrderUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const addresses = useAppSelector(state => state.address.entities);
  const customerOrders = useAppSelector(state => state.customerOrder.entities);
  const productOrderEntity = useAppSelector(state => state.productOrder.entity);
  const loading = useAppSelector(state => state.productOrder.loading);
  const updating = useAppSelector(state => state.productOrder.updating);
  const updateSuccess = useAppSelector(state => state.productOrder.updateSuccess);
  const productOrderStatusValues = Object.keys(ProductOrderStatus);

  const handleClose = () => {
    navigate('/product-order');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAddresses({}));
    dispatch(getCustomerOrders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.quantity !== undefined && typeof values.quantity !== 'number') {
      values.quantity = Number(values.quantity);
    }

    const entity = {
      ...productOrderEntity,
      ...values,
      serviceLocation: addresses.find(it => it.id.toString() === values.serviceLocation?.toString()),
      customerOrder: customerOrders.find(it => it.id.toString() === values.customerOrder?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'NEW',
          ...productOrderEntity,
          serviceLocation: productOrderEntity?.serviceLocation?.id,
          customerOrder: productOrderEntity?.customerOrder?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.productOrder.home.createOrEditLabel" data-cy="ProductOrderCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.productOrder.home.createOrEditLabel">
              Create or edit a ProductOrder
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="product-order-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.productOrder.quantity')}
                id="product-order-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.productOrder.status')}
                id="product-order-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {productOrderStatusValues.map(productOrderStatus => (
                  <option value={productOrderStatus} key={productOrderStatus}>
                    {translate(`crawlerBackendApp.ProductOrderStatus.${productOrderStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="product-order-serviceLocation"
                name="serviceLocation"
                data-cy="serviceLocation"
                label={translate('crawlerBackendApp.productOrder.serviceLocation')}
                type="select"
              >
                <option value="" key="0" />
                {addresses
                  ? addresses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="product-order-customerOrder"
                name="customerOrder"
                data-cy="customerOrder"
                label={translate('crawlerBackendApp.productOrder.customerOrder')}
                type="select"
              >
                <option value="" key="0" />
                {customerOrders
                  ? customerOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/product-order"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProductOrderUpdate;
